module.exports = __webpack_public_path__ + "static/media/hu.1f75d137.webp";